var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShow
    ? _c("div", { staticClass: "msg_wrap" }, [
        _c("div", { staticClass: "msg_content" }, [
          _c("i", {
            staticClass: "msg_icon",
            class: _vm.cont.type == "success" ? "icon_success" : "icon_fail"
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "msg_message", style: _vm.message_type_style },
            [_vm._v(_vm._s(_vm.cont.message))]
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d4b52f0a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4b52f0a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/myToast.vue
// module id = null
// module chunks = 